import React from "react";
import PlaceholderImage from "../../Assets/Images/SadGift.png";
import { useTranslation } from "react-i18next";

const NoSearchResults = ({ query }) => {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col items-center justify-center  sm:justify-center lg:justify-start lg:mt-24 min-h-screen text-center bg-stone-50 ">
      <img src={PlaceholderImage} alt="No results" className="w-72 h-72 mb-4" />
      <h2 className="text-2xl font-semibold text-gray-800 mb-2">
        {t("career.noResultsTitle")}
      </h2>
      <p className="text-lg text-gray-600">
        {t("career.noResultsDesc")}
      </p>
    </div>
  );
};

export default NoSearchResults;
